import { Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateUserRequest, CreateUserResponse } from '../../interfaces/create-user.interface';
import { ReactiveFormsModule, FormsModule, NgForm } from '@angular/forms';
import { ErrorAlertComponent } from "../shared/error-alert/error-alert.component"
import { SuccessAlertComponent } from "../shared/success-alert/success-alert.component";
import { LoadingService } from '../../services/general/loading.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import { CreateUserService } from '../../services/create-user/create-user.service'
import { LogTackingService } from '../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../interfaces/logs_tracking.interface.';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';


@Component({
  selector: 'app-create-user',
  standalone: true,
  imports: [CommonModule, FormsModule, ErrorAlertComponent, ReactiveFormsModule, SuccessAlertComponent, ConfirmationModalComponent, PageHeaderComponent],
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.css'
})
export class CreateUserComponent  implements OnInit{

  // Solicitudes pendientes
  pendingRequests: any[] = [];
  filteredRequests: any[] = [];
  pendingCount: number = 0;
  selectedRole: { [email: string]: string } = {};

  // Búsqueda y filtrado
  searchTerm: string = '';
  
  // Estados
  errorMessage: string = '';
  showAlertError: boolean = false;
  showAlertSuccess: boolean = false;
  successMessage: string = ''
  isAssignRoleModalVisible: boolean = false
  isRejectModalVisible: boolean = false
  selectedUserEmail: string = ''
  rols = ['admin', 'dev', 'cx', 'analytic', 'infraestructura', 'comercial', 'cdt']
  
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Asignar rol',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private _loadingService: LoadingService,
    private _logsService: LogTackingService,
    private _createUserService : CreateUserService
  ){ }

  ngOnInit(): void {
    this.loadPendingRequests();
  }

  loadPendingRequests(): void {
    this._loadingService.setLoading(true);
    this._createUserService.getUserPendingOfRole().subscribe({
      next: (response: any) => {
        this.pendingRequests = response.requests || [];
        this.filteredRequests = [...this.pendingRequests];
        this.pendingCount = response.count || 0;
        // Inicializar roles seleccionados por defecto
        this.pendingRequests.forEach(request => {
          this.selectedRole[request.email] = 'cx'; // rol por defecto
        });
        this._loadingService.setLoading(false);
      },
      error: (error) => {
        console.error('Error al cargar solicitudes pendientes:', error);
        this.errorMessage = 'No se pudieron cargar las solicitudes pendientes';
        this.showAlertError = true;
        setTimeout(() => {
          this.showAlertError = false;
        }, 3000);
        this._loadingService.setLoading(false);
      }
    });
  }

  filterRequests(): void {
    if (!this.searchTerm.trim()) {
      this.filteredRequests = [...this.pendingRequests];
    } else {
      const search = this.searchTerm.toLowerCase();
      this.filteredRequests = this.pendingRequests.filter(request => 
        request.email.toLowerCase().includes(search)
      );
    }
  }

  openAssignRoleModal(email: string): void {
    this.selectedUserEmail = email;
    this.isAssignRoleModalVisible = true;
  }

  onConfirmAssignRole(): void {
    const role = this.selectedRole[this.selectedUserEmail];
    
    if (!role) {
      this.errorMessage = 'Por favor selecciona un rol';
      this.showAlertError = true;
      setTimeout(() => {
        this.showAlertError = false;
      }, 3000);
      return;
    }

    this._loadingService.setLoading(true);
    this._createUserService.updateRoleUser(this.selectedUserEmail, role).subscribe({
      next: (response: any) => {
        console.log('Respuesta del servidor:', response);
        
        // Construir mensaje de éxito con la respuesta del backend
        this.successMessage = `${response.message || 'Rol actualizado exitosamente'}\n\nUsuario: ${response.username || this.selectedUserEmail}\nRol asignado: ${role}`;
        this.showAlertSuccess = true;
        this.isAssignRoleModalVisible = false;
        
        // Registrar en logs
        this.log_info.details = `Success: Rol ${role} asignado a ${this.selectedUserEmail}`;
        this.log_info.action = 'Asignar rol';
        this.createTrackingLog();
        
        // Recargar solicitudes pendientes después de un breve delay
        setTimeout(() => {
          this.showAlertSuccess = false;
          this.loadPendingRequests();
        }, 3000);
        
        this._loadingService.setLoading(false);
      },
      error: (error) => {
        console.error('Error al asignar rol:', error);
        this.errorMessage = error.error?.message || 'Error al asignar el rol. Intenta nuevamente.';
        this.showAlertError = true;
        
        // Registrar error en logs
        this.log_info.details = `Error: ${this.errorMessage}`;
        this.log_info.action = 'Asignar rol';
        this.createTrackingLog();
        
        setTimeout(() => {
          this.showAlertError = false;
        }, 3000);
        
        this.isAssignRoleModalVisible = false;
        this._loadingService.setLoading(false);
      }
    });
  }

  onCancelAssignRole(): void {
    this.isAssignRoleModalVisible = false;
    this.selectedUserEmail = '';
  }

  openRejectModal(email: string): void {
    this.selectedUserEmail = email;
    this.isRejectModalVisible = true;
  }

  onConfirmReject(): void {
    this._loadingService.setLoading(true);
    this._createUserService.rejectRequest(this.selectedUserEmail).subscribe({
      next: (response: any) => {
        console.log('Solicitud rechazada:', response);
        
        this.successMessage = `Solicitud rechazada exitosamente\n\nUsuario: ${this.selectedUserEmail}`;
        this.showAlertSuccess = true;
        this.isRejectModalVisible = false;
        
        // Registrar en logs
        this.log_info.details = `Success: Solicitud rechazada de ${this.selectedUserEmail}`;
        this.log_info.action = 'Rechazar solicitud';
        this.createTrackingLog();
        
        // Recargar solicitudes pendientes
        setTimeout(() => {
          this.showAlertSuccess = false;
          this.loadPendingRequests();
        }, 3000);
        
        this._loadingService.setLoading(false);
      },
      error: (error) => {
        console.error('Error al rechazar solicitud:', error);
        this.errorMessage = error.error?.message || 'Error al rechazar la solicitud. Intenta nuevamente.';
        this.showAlertError = true;
        
        // Registrar error en logs
        this.log_info.details = `Error: ${this.errorMessage}`;
        this.log_info.action = 'Rechazar solicitud';
        this.createTrackingLog();
        
        setTimeout(() => {
          this.showAlertError = false;
        }, 3000);
        
        this.isRejectModalVisible = false;
        this._loadingService.setLoading(false);
      }
    });
  }

  onCancelReject(): void {
    this.isRejectModalVisible = false;
    this.selectedUserEmail = '';
  }

  formatDate(dateString: string): string {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString;
      }
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (error) {
      return dateString;
    }
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }
}
